<template>
    <div class="container pt-4 mb-5">
        <kt-col lg="12" md="12" xs="12" class="text-center mt-5 mb-3" style="text-align: center">
            <img v-if="form_data.site_logo"
                 style="max-height: 200px; max-width: 200px; text-align: center"
                 :src="form_data.site_logo"
                 alt="logo"
            >
        </kt-col>
        <table class="table border border-secondary">
            <thead>
            <tr>
                <td>{{ $t('pardakht_shakhsi.form.label.payment_result') }}</td>
                <td
                        v-if="form_data.payment_status === 1 || form_data.payment_status === '1'"
                        class="success font-weight-bold"
                >
                    {{ $t('pardakht_shakhsi.form.label.payment_success') }}
                </td>
                <td
                        v-if="form_data.payment_status === 2 || form_data.payment_status === '2'"
                        class="danger font-weight-bold"
                >
                    {{ $t('pardakht_shakhsi.form.label.payment_fail') }}
                </td>
            </tr>
            </thead>
            <tbody>
            <tr v-if="form_data.payment_status === 2 || form_data.payment_status === '1'">
                <td>{{ $t('pardakht_shakhsi.form.label.bank_tracking_number') }}</td>
                <td>{{ form_data.bank_tracking_number }}</td>
            </tr>
            <tr>
                <td>{{ $t('pardakht_shakhsi.form.label.tracking_number') }}</td>
                <td>{{ form_data.tracking_number }}</td>
            </tr>
            <tr>
                <td>{{ $t('pardakht_shakhsi.form.label.payer_phone') }}</td>
                <td>{{ form_data.payer_phone_number }}</td>
            </tr>
            <tr>
                <td>{{ $t('pardakht_shakhsi.form.label.payment_dest') }}</td>
                <td>{{ form_data.user_full_name }}</td>
            </tr>
            <tr>
                <td>{{ $t('pardakht_shakhsi.form.label.price') }}</td>
                <td>{{ form_data.amount + ' ' + $t('currency.rial') }}
                    <span style="color:limegreen;">
                        {{
                        ' + ('
                    + form_data.payer_wage + ' ' + $t('currency.rial')
                    + ' ' + $t('pardakht_shakhsi.form.label.payer_wage') + ')'
                        }}
                    </span>
                </td>
            </tr>
            <tr>
                <td>{{ $t('label.date_payed') }}</td>
                <td>{{ form_data.date_payed }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: "receiptForm",
        props: {
            form_data: {
                default() {
                    return {}
                }
            },
        },
    }
</script>

<style scoped>
    .success {
        color: darkgreen;
        background-color: lightgreen;
    }.danger {
        color: darkred;
        background-color: lightpink;
    }
</style>
